import(/* webpackMode: "eager" */ "/integrate-app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/integrate-app/node_modules/react-toastify/dist/ReactToastify.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/integrate-app/src/app/components/App/App.tsx");
;
import(/* webpackMode: "eager" */ "/integrate-app/src/styles/global.css");
;
import(/* webpackMode: "eager" */ "/integrate-app/src/components/form/datePicker/datePicker.css");
